/**
 * Settings Related utilities
 */

// Log In
export const SETTINGS_LOGIN_USERNAME = "loginUsername"
export const SETTINGS_LOGIN_PASSWORD = "loginPassword"

// SMTP
export const SETTINGS_SMTP_USERNAME = "smtpUsername"
export const SETTINGS_SMTP_PASSWORD = "smtpPassword"

// Mail Templates
export const SETTINGS_MAIL_TEMPLATE_CREATED_BODY = "mailAppointmentCreatedBody";
export const SETTINGS_MAIL_TEMPLATE_CREATED_SUBJECT = "mailAppointmentCreatedSubject";
export const SETTINGS_MAIL_TEMPLATE_RESCHEDULED_BODY = "mailAppointmentRescheduledBody";
export const SETTINGS_MAIL_TEMPLATE_RESCHEDULED_SUBJECT = "mailAppointmentRescheduledSubject";
export const SETTINGS_MAIL_TEMPLATE_CANCELLED_BODY = "mailAppointmentCancelledBody";
export const SETTINGS_MAIL_TEMPLATE_CANCELLED_SUBJECT = "mailAppointmentCancelledSubject";

// SMS
export const SETTINGS_SMS_USERNAME = "smsUsername"
export const SETTINGS_SMS_PASSWORD = "smsPassword"
export const SETTINGS_SMS_TITLE = "smsTitle"
export const SETTINGS_SMS_URL = "smsUrl"

// SMS Templates
export const SETTINGS_SMS_TEMPLATE_CREATED_BODY = "smsAppointmentCreatedBody";
export const SETTINGS_SMS_TEMPLATE_RESCHEDULED_BODY = "smsAppointmentRescheduledBody";
export const SETTINGS_SMS_TEMPLATE_CANCELLED_BODY = "smsAppointmentCancelledBody";